import React, { Fragment } from 'react';
import _ from 'lodash';
import { Card, CardBody, CardHeader, Collapse, FormGroup, Input, Label } from 'reactstrap';
import qs from 'qs';
import { withRouter } from 'react-router-dom';

import { urlify } from '../../utils';
import CollapseButton from '../dumb/collapseButton';
import baseFilter from './baseFilter';

class StageFilter extends baseFilter {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            filters: {}
        };

        this.aggregates = {
            'sample.tnm_integrated': 'count'
        };

        this.toggleCheckbox = this.toggleCheckbox.bind(this);
        this.toggleCollapse = this.toggleCollapse.bind(this);
        this.processResponse = this.processResponse.bind(this);
        this.updateAPIURL = this.updateAPIURL.bind(this);
    }

    static getFiltersFromQS(qsObj, oldFilters = {}) {
        const activeStages = ('tnm_integrated' in qsObj)
            ? _.split(qsObj.tnm_integrated, '_')
            : [];

        return _.reduce(
            oldFilters,
            (result, filterProps, stage) => {
                result[stage] = {
                    ...filterProps,
                    active: activeStages.indexOf(urlify(stage)) >= 0
                };
                return result;
            },
            {}
        );
    }

    static getDerivedStateFromProps(newProps, oldState) {
        const currentQS = qs.parse(
            newProps.location.search,
            { ignoreQueryPrefix: true }
        );

        const newFilters = StageFilter.getFiltersFromQS(
            currentQS,
            oldState.filters
        );

        return {
            filters: newFilters,
            activeCount: _.filter(newFilters, 'active').length
        };
    }

    toggleCollapse() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    updateAPIURL(apiQS, newListProps) {
        const newQS = qs.parse(
            newListProps.location.search,
            { ignoreQueryPrefix: true }
        );

        const activeStages = ('tnm_integrated' in newQS)
            ? _.split(newQS.tnm_integrated, '_')
            : [];

        const apiStageFilters = _.toPairs(this.state.filters)
            .filter(([stage]) =>
                activeStages.indexOf(urlify(stage)) >= 0
            )
            .map(([stage]) => stage);

        if (apiStageFilters.length > 0) {
            const filterQS = {
                name: 'sample',
                op: 'has',
                val: {
                    name: 'tnm_integrated',
                    op: 'in',
                    val: apiStageFilters
                }
            };

            apiQS.filter = _.get(apiQS, 'filter', []).concat(filterQS);
        }

        return _.merge(apiQS, {
            agg: this.aggregates
        });
    }

    processResponse(response) {
        const respAgg = this.get_agg_values(response);
        const aggField = _.keys(this.aggregates)[0];

        if (!respAgg || !respAgg[aggField]) {
            return;
        }

        const counts = respAgg[aggField][this.aggregates[aggField]];

        if (!counts) {
            return;
        }

        /*
         * Keep the existing filters instead of replacing them.
         * This is important because the aggregation response can
         * contain only the values currently returned by the API.
         */
        const newFilters = _.reduce(
            counts,
            (result, count, stage) => {
                if (stage === 'None' || stage === 'null' || stage === null) {
                    return result;
                }

                const existing = this.state.filters[stage] || {
                    active: false
                };

                result[stage] = {
                    ...existing,
                    count: count
                };

                return result;
            },
            { ...this.state.filters }
        );

        this.setState({
            filters: newFilters
        });
    }

    toggleCheckbox(event) {
        const stage = event.target.name;

        const currentQS = qs.parse(
            window.location.search,
            { ignoreQueryPrefix: true }
        );

        let stageFilter = ('tnm_integrated' in currentQS)
            ? _.split(currentQS.tnm_integrated, '_')
            : [];

        const stageValue = urlify(stage);

        if (event.target.checked) {
            if (stageFilter.indexOf(stageValue) === -1) {
                stageFilter.push(stageValue);
            }
        } else {
            stageFilter = stageFilter.filter(
                item => item !== stageValue
            );
        }

        currentQS.tnm_integrated =
            stageFilter.length > 0
                ? _.join(stageFilter.sort(), '_')
                : undefined;

        currentQS.page = undefined;

        this.props.history.push(
            window.location.pathname +
            qs.stringify(currentQS, { addQueryPrefix: true })
        );
    }

    renderStageCheckboxes() {
        const filters = this.state.filters || {};

        let active = [];
        let inactive = [];

        _.toPairs(filters).forEach(([stage, details]) => {
            const checkbox = (
                <FormGroup check key={stage}>
                    <Input
                        type="checkbox"
                        name={stage}
                        onChange={this.toggleCheckbox}
                        checked={!!details.active}
                    />

                    {' '}

                    <Label className="ml-4 mt-1" check>
                        {stage}

                        {details.count !== undefined && (
                            <span className="secondary">
                                {' '}({details.count})
                            </span>
                        )}
                    </Label>
                </FormGroup>
            );

            if (details.active) {
                active.push(checkbox);
            } else {
                inactive.push(checkbox);
            }
        });

        return (
            <Fragment>
                {active}
                {inactive}
            </Fragment>
        );
    }

    componentDidMount() {
        this.props.registerResponse(this.processResponse);
        this.props.registerRequest(this.updateAPIURL);
    }

    componentWillUnmount() {
        this.props.unregisterResponse(this.processResponse);
        this.props.unregisterRequest(this.updateAPIURL);
    }

    render() {
        return (
            <Card className="mb-2 z0 hover">
                <CardHeader
                    className="justify-content-between d-flex"
                    onClick={this.toggleCollapse}
                >
                    <div className="d-inline w-50">
                        Tumour Stage
                    </div>

                    <div className="d-inline-block">
                        {this.state.activeCount > 0 && (
                            <strong>
                                {this.state.activeCount} active
                            </strong>
                        )}
                    </div>

                    <CollapseButton
                        isOpen={this.state.isOpen}
                        onClick={this.toggleCollapse}
                    />
                </CardHeader>

                <Collapse isOpen={this.state.isOpen}>
                    <CardBody>
                        {this.renderStageCheckboxes()}
                    </CardBody>
                </Collapse>
            </Card>
        );
    }
}

export default withRouter(StageFilter);